import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Form, Button, Table, Dropdown } from 'react-bootstrap';
import '../../Styles/yellocalfcss/YearlyIncomeReport.css';

function YearlyIncomeReport() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const expectedIncomeData = [
    { category: 'Fee', amount: 0 },
    { category: 'Busfare', amount: 0 },
    { category: 'Registration', amount: 50 },
    { category: 'Cashless Recharge', amount: 0 }
  ];

  const collectedIncomeData = [
    { category: 'Fee', amount: 0 },
    { category: 'Busfare', amount: 0 },
    { category: 'Registration', amount: 50 },
    { category: 'Cashless Recharge', amount: 0 }
  ];

  const pendingIncomeData = [
    { category: 'Fee', amount: 0 },
    { category: 'Busfare', amount: 0 },
    { category: 'Registration', amount: 0 },
    { category: 'Cashless Recharge', amount: 0 }
  ];

  const handleExport = (selectedOption) => {
    console.log('Export option selected:', selectedOption);
  };

 const handleSearch = () => {
  window.location.reload();
};


  return (
    <Container fluid className="report-container">
      <div className="report-header-section">
        <Row className="report-header-row">
          <Col md={8}>
            <h2 className="report-title">Yearly Income Summary Report</h2>
          </Col>
          <Col md={4} className="exports-btn-container">
            <Dropdown>
              <Dropdown.Toggle variant="warning" id="dropdown-basic" className="export-btn">
                Export
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleExport('Save as PDF')}>Save as PDF</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </div>

      <Row className="date-selection-row">
        <Col md={4}>
          <Form.Group className="start-date-group">
            <Form.Control
              type="date"
              className="date-input"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="end-date-group">
            <Form.Control
              type="date"
              className="date-input"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4} className="search-btn-container">
          <Button
            variant="warning"
            className="search-btn"
            onClick={handleSearch}
          >
            Search
          </Button>
        </Col>
      </Row>

      <div className="income-section-container">

        <div className="income-section-heading-row">
          <div className="income-section-heading-cell">Expected Income</div>
        </div>
        <Table bordered hover responsive className="income-table">
          <thead>
            <tr className="table-header-row">
              <th>Category</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {expectedIncomeData.map((item, index) => (
              <tr key={index}>
                <td>{item.category}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="income-section-heading-row">
          <div className="income-section-heading-cell">Collected Income</div>
        </div>
        <Table bordered hover responsive className="income-table">
          <thead>
            <tr className="table-header-row">
              <th>Category</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {collectedIncomeData.map((item, index) => (
              <tr key={index}>
                <td>{item.category}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="income-section-heading-row">
          <div className="income-section-heading-cell">Pending / Upcoming Income</div>
        </div>
        <Table bordered hover responsive className="income-table">
          <thead>
            <tr className="table-header-row">
              <th>Category</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {pendingIncomeData.map((item, index) => (
              <tr key={index}>
                <td>{item.category}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </Table>

      </div>
    </Container>
  );
}

export default YearlyIncomeReport;
